const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL;

const SUPABASE_KEY =
  process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;


function headers() {
  return {
    apikey:
      SUPABASE_KEY,

    Authorization:
      'Bearer ' +
      SUPABASE_KEY,

    'Content-Type':
      'application/json'
  };
}


async function rpc(
  name,
  body,
  label
) {
  const response =
    await fetch(
      SUPABASE_URL +
        '/rest/v1/rpc/' +
        name,
      {
        method:
          'POST',

        headers:
          headers(),

        body:
          JSON.stringify(
            body
          )
      }
    );


  const text =
    await response.text();


  let result =
    null;

  if (text) {
    try {
      result =
        JSON.parse(text);
    } catch {
      result =
        null;
    }
  }


  if (
    !response.ok ||
    result?.ok === false
  ) {
    throw new Error(
      result?.message ||
      label +
        ' failed (' +
        response.status +
        ').'
    );
  }


  return result;
}


export async function
fetchNotificationRoster(
  session,
  courseId
) {
  const result =
    await rpc(
      'instructor_notification_course_roster',
      {
        p_cms_token:
          session?.cmsToken ||
          '',

        p_course_id:
          courseId
      },
      'Loading notification recipients'
    );


  return Array.isArray(
    result?.students
  )
    ? result.students
    : [];
}


export async function
fetchCourseNotificationHistory(
  session,
  courseId
) {
  const result =
    await rpc(
      'instructor_course_notifications',
      {
        p_cms_token:
          session?.cmsToken ||
          '',

        p_course_id:
          courseId
      },
      'Loading notifications'
    );


  return Array.isArray(
    result?.notifications
  )
    ? result.notifications
    : [];
}


export async function
deleteCourseNotification(
  session,
  courseId,
  notificationId
) {
  return rpc(
    'instructor_delete_course_notification',
    {
      p_cms_token:
        session?.cmsToken ||
        '',

      p_course_id:
        courseId,

      p_notification_id:
        notificationId
    },
    'Deleting notification'
  );
}


export async function
sendCourseNotification(
  session,
  {
    courseId,
    message,
    targetMode = 'all',
    studentIds = []
  }
) {
  const cleanMessage =
    String(
      message || ''
    ).trim();


  if (!cleanMessage) {
    throw new Error(
      'Enter a notification.'
    );
  }


  if (
    targetMode ===
      'individual' &&
    (
      !Array.isArray(
        studentIds
      ) ||
      studentIds.length === 0
    )
  ) {
    throw new Error(
      'Select at least one student.'
    );
  }


  const result =
    await rpc(
      'instructor_create_course_notification',
      {
        p_cms_token:
          session?.cmsToken ||
          '',

        p_course_id:
          courseId,

        p_message:
          cleanMessage,

        p_target_mode:
          targetMode,

        p_student_ids:
          targetMode ===
            'individual'
            ? studentIds
            : []
      },
      'Sending notification'
    );


  const created =
    result?.notification;


  if (!created?.id) {
    throw new Error(
      'Notification was not created.'
    );
  }


  let push =
    null;


  try {
    const response =
      await fetch(
        SUPABASE_URL +
          '/functions/v1/send-student-push',
        {
          method:
            'POST',

          headers: {
            'Content-Type':
              'application/json'
          },

          body:
            JSON.stringify({
              notificationId:
                created.id
            })
        }
      );


    const text =
      await response.text();


    if (text) {
      try {
        push =
          JSON.parse(text);
      } catch {
        push =
          null;
      }
    }


    if (!response.ok) {
      throw new Error(
        push?.error ||
        text ||
        'Push delivery failed.'
      );
    }

  } catch (error) {
    console.error(
      'Notification was saved but push delivery failed:',
      error
    );

    push = {
      ok: false,
      error:
        error?.message ||
        String(error)
    };
  }


  return {
    notification: {
      ...created,

      recipientCount:
        result?.recipientCount ??
        null
    },

    recipientCount:
      result?.recipientCount ??
      null,

    push
  };
}
